const internationalMinutesTooltipStyle = (theme) => ({
	countries: {
		maxHeight: 320,
		display: 'flex',
		flexDirection: 'column',
		flexWrap: 'wrap',
		marginBottom: 24,
		'& > div': {
			width: 106,
		},
		[theme.breakpoints.down('sm')]: {
			maxHeight: 600,
		},
	},
	dialingCodes: {
		marginTop: 16,
	},
	dialingCode: {
		display: 'flex',
		marginBottom: 16,
	},
	dialingCountry: {
		width: 90,
	},
	codesArray: {
		maxWidth: 296,
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
	},
});

export default internationalMinutesTooltipStyle;
